import React from 'react';

type NextPaymentFreeBarProps = {
  totalPrice: string | number;
  nextPaymentDate: string;
  className?: string;
  totalPriceTestId?: string;
};

export const NextPaymentFreeBar = ({
  nextPaymentDate,
  totalPrice,
  className = '',
  totalPriceTestId = 'addCollaboratorsPage-subtotal-text',
}: NextPaymentFreeBarProps) => {
  return (
    <div className={`flex justify-between mt-2 ${className}`}>
      <span className='text-black'>{`Next payment (${nextPaymentDate})`}</span>
      <span className='text-black' data-testid={totalPriceTestId}>
        €{totalPrice}
      </span>
    </div>
  );
};
